module.exports = __webpack_public_path__ + "9fdaef014892d82a252ce8f265c80ba2.png";